import { bookingUrl, SITE_CONFIG } from "@/config/site";
import type { Locale } from "@/i18n";

interface ContactInfo {
  sectionLabel: string;
  email: string;
  bookingUrl: string;
  auditBookingUrl: string;
  location: string;
  availability: string;
  ctaLabel: string;
  auditCtaLabel: string;
}

const en: ContactInfo = {
  sectionLabel: "Contact",
  email: SITE_CONFIG.en.contact.email,
  bookingUrl: bookingUrl("build", "contact"),
  auditBookingUrl: bookingUrl("ai-audit", "contact"),
  location: "Remote · Europe timezone",
  availability:
    "Bring us a build and you get a scope, a price, and a date. If you are still only guessing where AI could help, start with the audit instead: scope agreed up front, fixed price, and a roadmap you keep either way.",
  ctaLabel: "Let's talk about your build →",
  auditCtaLabel: "Or ask for an AI audit first →",
};

const hu: ContactInfo = {
  sectionLabel: "Kapcsolat",
  email: SITE_CONFIG.hu.contact.email,
  bookingUrl: bookingUrl("build", "contact"),
  auditBookingUrl: bookingUrl("ai-audit", "contact"),
  location: "Budapest · távmunkában és személyesen is",
  availability:
    "Hozz egy fejlesztési feladatot, és megmondjuk, mennyi idő és mennyi pénz. Ha viszont még csak sejted, hogy valahol AI-jal gyorsítani lehetne, indulj az AI-audittal: előre rögzített terjedelem, fix ár, és egy ütemterv, ami akkor is a tiéd marad, ha végül nem velünk valósítod meg.",
  ctaLabel: "Beszéljünk a fejlesztésedről →",
  auditCtaLabel: "Vagy kezdjük egy AI-audittal →",
};

export const CONTACT_INFO: Record<Locale, ContactInfo> = {
  en,
  hu,
};
